// extracted by mini-css-extract-plugin
export var infoItem = "_ql-2";
export var title = "_ql-0";
export var value = "_ql-1";